var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiramisu = function SvgTiramisu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tiramisu_svg__a)",
    d: "M229.129 121.184 173.487 82.61a9.04 9.04 0 0 0-7.986-1.154l-122.315 40.37A9 9 0 0 0 37 130.364v49.642A9.01 9.01 0 0 0 46.021 189h177.958a9.01 9.01 0 0 0 9.021-8.994v-51.438a8.99 8.99 0 0 0-3.871-7.384"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tiramisu_svg__a",
    x1: 98.544,
    x2: 127.252,
    y1: 205.416,
    y2: 75.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#238DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#3C9AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#64AED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#9BCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#E0EFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgTiramisu;